import SimpleSearchV from '../view/recordm.view.simplesearch.js';

// The "Presenter" responsible for showing the simple search form
//
// * `core`: a cob.app instance
// * `moduleBaseUri`: the base uri for this module
// * `entityM`: the definitionM that you are using to search.
// * `simpleSearchM`: The simple search Model
// * `$container` : the jquery HTML wrapper for the enclosing element
var SimpleSearchP = function(core, moduleBaseUri, entityM, simpleSearchM, $container, confs, callbacks) {

    var _entityM = entityM,
        _loadingKey = core.getLoadingKey();

    let _searchView = undefined;
    const showSearchView = ($container !== undefined);

    var _doSearch = function(searchText) {
        if (simpleSearchM.getCurrentQuery() === searchText) {
            // if the search or active view haven't changed to a simple refresh
            simpleSearchM.refresh();

        } else {
            callbacks.updateUri({searchText})
        }
    };

    var _onSearchFinished = function(e, data) {
        if (data && data.simpleSearch) {
            core.hideLoading(_loadingKey, "simpleSearchP._onSearchFinished");
        }
    };

    const _search = function(query) {
        var currentView = callbacks && callbacks.getCurrentVisualization(),
            sortedColumn = {};

        if (query !== undefined) {
            core.showLoading(_loadingKey, "simpleSearchP._init");

            if (currentView) {
                sortedColumn = currentView.getSortedColumn() || sortedColumn;

            } else if(simpleSearchM.isSorted()){
               sortedColumn = {
                  column: simpleSearchM.getSortField(),
                  ascending: simpleSearchM.isSortAscending()
               }
            }

            if(showSearchView) _searchView.setSearchQuery(query);
            simpleSearchM.doSearch(query, 0, sortedColumn.column, sortedColumn.ascending);
        }
    };

    const _instantiateView = function() {
        _searchView = new SimpleSearchV(core, $container, entityM, simpleSearchM, confs, {
            showAdvancedSearch: function() {
                callbacks.goToAdvancedSearch();
            },
            doSearch: function(query) {
                _doSearch(query);
            },
            filterChanged: function(selectedLabels) {
                callbacks.updateUri({selectedLabels})
            }
        });
    };

    const _buildCustomFilter = function() {
        return (simpleSearchM.getFilters() ?? [])
            .filter((el) => el.selected)
            .map((el) => "(" + el.query + ")")
            .join(" AND ");
    }

    var _init = function(query) {

        if(showSearchView){
           _instantiateView();
        }

        simpleSearchM.setQueryFilter(_buildCustomFilter());

        core.subscribe("recordm:search:finished", _onSearchFinished);

        if(showSearchView){
            _searchView.start();
            _searchView.setFocusOnSearch();
        }

        _search(query);
    };

    var _resume = function() {
        core.subscribe("recordm:search:finished", _onSearchFinished);

        if(showSearchView) {
            // If a MultipleSearchP starts with an advanced query, this SearchP won't have initiated yet
            // When chaning form the advanced to a simple search, this SearchP will be resumed, so we need to
            // intantiate the view here
            if(_searchView === undefined) _instantiateView();

            _searchView.start();
            _searchView.setFocusOnSearch();
        }
    };

    var _pause = function() {
        if(showSearchView && _searchView !== undefined) _searchView.stop();

        //we call hideLoading to clear any ongoing search before pausing
        core.hideLoading(_loadingKey, "simpleSearchP._pause");

        core.unsubscribe("recordm:search:finished", _onSearchFinished);
    };

    var _destroy = function() {
        if(showSearchView && _searchView !== undefined) _searchView.destroy();

        //we call hideLoading to clear any ongoing search before exiting
        core.hideLoading(_loadingKey, "simpleSearchP._destroy");

        core.unsubscribe("recordm:search:finished", _onSearchFinished);
    };

    return{
        name: "simple-search",

        init: _init,
        resume: _resume,
        pause: _pause,
        destroy: _destroy,

        updateDomainM: function(domainM) {
            _entityM = domainM;
        },
        refresh: function() {
            simpleSearchM.refresh();
        },
        prepareView: function (){
            if(showSearchView) _searchView.setFocusOnSearch();
        },
        doSearch: _search
    };
};


export default SimpleSearchP;
